import { render, staticRenderFns } from "./APIUserCreateToken.vue?vue&type=template&id=236f22b0&scoped=true&"
import script from "./APIUserCreateToken.vue?vue&type=script&lang=js&"
export * from "./APIUserCreateToken.vue?vue&type=script&lang=js&"
import style0 from "./APIUserCreateToken.vue?vue&type=style&index=0&id=236f22b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236f22b0",
  null
  
)

export default component.exports